var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSkeletonLoader',_vm._b({staticClass:"vd-header-loading",attrs:{"width":_vm.width,"height":_vm.height,"type":"heading","aria-hidden":"true"}},'VSkeletonLoader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }